export { default } from './short-code-payment-result-modal';
